import store from '~/store'

export default (to, from, next) => {
  if (store.getters['auth/user'].role !== 'admin') {
    //next({ name: 'project.select' })
    next({ name: 'group.select' })
  } else {
    next()
  }
}
